import { JsonObject } from "../interface/json";
const d = window as any;
export const meetingService = {
  getSeminar(info: JsonObject): Promise<any> {
    const path = "seminar/topicTemplate/seminar/get";
    return d.$sk.$skxhrp(path, info);
  },

  getWebinar(info: JsonObject): Promise<any> {
    const path = "webinar/open/getWebinarInfo";
    return d.$sk.$skxhrp(path, info);
  },

  getCustomForm(info: JsonObject): Promise<any> {
    const path = "api/customform/get";
    return d.$sk.$skxhrp(path, info);
  },

  getForNewForm(info: JsonObject): Promise<any> {
    const path = "member/form/GetForNewForm";
    return d.$sk.$skxhrp(path, info);
  },
  //静默报名
  silentSignUp(info: JsonObject): Promise<any> {
    const path = "api/webinar/contacts/signup";
    return d.$sk.$skxhrp(path, info);
  },
  //检查是否报名
  checkRegistration: (info) => {
    const path = "webinar/open/checkRegistration";
    return d.$sk.$skxhrp(path, info);
  },
  //获取人信息
  getMemberContacts: (info) => {
    const path = "api/member/contacts/info/get";
    return d.$sk.$skxhrp(path, info);
  },
  //获取参会人信息
  getContacts: (info) => {
    return d.$sk.$skxhrp("api/webinar/contacts/get", info);
  },
  join: (info) => {
    return d.$sk.$skxhrp("webinar/open/join", info);
  },
  //获取保利威频道签名
  getSign: (info) => {
    return d.$sk.$skxhrp("api/webinar/getSign", info);
  }, //获取服务器时间
  getServerTime: (info) => {
    return d.$sk.$skxhrp("webinar/open/getServerTime", info);
  }, //检查session是否过期
  checkSess: (info) => {
    return d.$sk.$skxhrp("anonymous/checkSess", info);
  },
  //获取会议信息
  getMeeting: (info) => {
    // return $sxhr.post("api/webinar/get", info);
    return d.$sk.$skxhrp("api/webinar/get", info);
  },
  //记录浏览行为
  activeRecords: (info) => {
    return d.$sk.$skxhrp("api/webinar/live/site/browse", info);
  },
  getPosterStatus: (info) => {
    return d.$sk.$skxhrp("template/platform/instance/getStatus", info);
  },
  //获取海报分享地址
  getPosterShareUrl: (info) => {
    return d.$sk.$skxhrp("template/platform/instance/getUrl", info);
  },
  //获取视频回放列表
  getVideoPlayback: (info) => {
    return d.$sk.$skxhrp("api/webinar/replay/getList", info);
  },
  logoutWeChat: (info) => {
    return d.$sk.$skxhrp("member/member/associate/Logout", info);
  },
  //获取登录注册的地址
  getRegistrationForm: (info) => {
    return d.$sk.$skxhrp("member/form/GetForNewForm", info);
  },
  //获取报名人状态
  getSwebinarSignUpStatus: (info) => {
    return d.$sk.$skxhrp("api/webinar/contacts/status", info);
  },
};
